"use client";

import { Spinner } from "@heroui/react";

export function LoadingSpinner() {
  return (
    <div className="flex justify-center items-center min-h-[200px]">
      <Spinner size="lg" />
    </div>
  );
}
